import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMaterialUsage = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_805_901)",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_805_901",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 24,
			height: 25,
			children: /* @__PURE__ */ _jsx("rect", {
				y: .00734711,
				width: 24,
				height: 24,
				fill: "currentColor"
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_805_901)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M2.5 19.5073V8.3631H5.4135V4.50735H10.8077V8.3631H13.1923V4.50735H18.5865V8.3631H21.5V19.5073H2.5ZM4 18.0073H20V9.8631H4V18.0073ZM6.9135 8.3631H9.30775V6.00735H6.9135V8.3631ZM14.6923 8.3631H17.0865V6.00735H14.6923V8.3631Z",
				fill: "currentColor"
			})
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_805_901",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "currentColor"
		})
	}) })]
});
export default SvgMaterialUsage;
